// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { MDParameter } from './MDParameter';
import { EntityMethod } from './EntityMethod';
import { InterfaceMethod } from './InterfaceMethod';
import { ValueObjectMethod } from './ValueObjectMethod';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 方法参数 实体类
 * 方法参数
 */
export class MethodParameter extends MDParameter {
  /** 实体方法 的ID */
  private _entityMethod_ID: string;

  /** 获取：实体方法 的ID */
  public get entityMethod_ID() {
    return this._entityMethod_ID;
  }

  /** 设置：实体方法 的ID */
  public set entityMethod_ID(value: string) {
    this._entityMethod_ID = value;
  }

  /** 实体方法  */
  private _entityMethod: EntityMethod;

  /** 获取：实体方法  */
  public get entityMethod() {
    return this._entityMethod;
  }

  /** 设置：实体方法  */
  public set entityMethod(value: EntityMethod) {
    this._entityMethod = value;
    if (value !== null) {
      this.entityMethod_ID = value.id;
    } else {
      this.entityMethod_ID = '';
    }
  }

  /** 接口方法 的ID */
  private _interfaceMethod_ID: string;

  /** 获取：接口方法 的ID */
  public get interfaceMethod_ID() {
    return this._interfaceMethod_ID;
  }

  /** 设置：接口方法 的ID */
  public set interfaceMethod_ID(value: string) {
    this._interfaceMethod_ID = value;
  }

  /** 接口方法  */
  private _interfaceMethod: InterfaceMethod;

  /** 获取：接口方法  */
  public get interfaceMethod() {
    return this._interfaceMethod;
  }

  /** 设置：接口方法  */
  public set interfaceMethod(value: InterfaceMethod) {
    this._interfaceMethod = value;
    if (value !== null) {
      this.interfaceMethod_ID = value.id;
    } else {
      this.interfaceMethod_ID = '';
    }
  }

  /** 值对象方法 的ID */
  private _valueObjectMethod_ID: string;

  /** 获取：值对象方法 的ID */
  public get valueObjectMethod_ID() {
    return this._valueObjectMethod_ID;
  }

  /** 设置：值对象方法 的ID */
  public set valueObjectMethod_ID(value: string) {
    this._valueObjectMethod_ID = value;
  }

  /** 值对象方法  */
  private _valueObjectMethod: ValueObjectMethod;

  /** 获取：值对象方法  */
  public get valueObjectMethod() {
    return this._valueObjectMethod;
  }

  /** 设置：值对象方法  */
  public set valueObjectMethod(value: ValueObjectMethod) {
    this._valueObjectMethod = value;
    if (value !== null) {
      this.valueObjectMethod_ID = value.id;
    } else {
      this.valueObjectMethod_ID = '';
    }
  }

  constructor() {
    super();
    this._entityMethod_ID = '';
    this._entityMethod = null;
    this._interfaceMethod_ID = '';
    this._interfaceMethod = null;
    this._valueObjectMethod_ID = '';
    this._valueObjectMethod = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: MethodParameter, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.entityMethod_ID = element.entityMethod_ID;
      if (hasReference && element.entityMethod !== null) {
        this.entityMethod = element.entityMethod;
      }
      this.interfaceMethod_ID = element.interfaceMethod_ID;
      if (hasReference && element.interfaceMethod !== null) {
        this.interfaceMethod = element.interfaceMethod;
      }
      this.valueObjectMethod_ID = element.valueObjectMethod_ID;
      if (hasReference && element.valueObjectMethod !== null) {
        this.valueObjectMethod = element.valueObjectMethod;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.entityMethod_ID = json.EntityMethod_ID;
    // if (json.EntityMethod !== null) {
    //   this.entityMethod = EntityMethod.Create(json.EntityMethod);
    // }
    this.interfaceMethod_ID = json.InterfaceMethod_ID;
    // if (json.InterfaceMethod !== null) {
    //   this.interfaceMethod = InterfaceMethod.Create(json.InterfaceMethod);
    // }
    this.valueObjectMethod_ID = json.ValueObjectMethod_ID;
    // if (json.ValueObjectMethod !== null) {
    //   this.valueObjectMethod = ValueObjectMethod.Create(json.ValueObjectMethod);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.EntityMethod_ID = this.entityMethod_ID;
    json.InterfaceMethod_ID = this.interfaceMethod_ID;
    json.ValueObjectMethod_ID = this.valueObjectMethod_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): MethodParameter {
    const methodParameter = new MethodParameter();
    methodParameter.Deserialize(json);
    methodParameter.json = json;
    return methodParameter;
  }
}
